<template>
  <div>
    <template v-if="showDistributionPicker">
      <h3 class="step-title">Wybierz rodzaj dystrybucji karty wirtualnej</h3>
      <div class="distributionContainer">
        <DistributionTile
          v-for="item in Object.entries(distributionTypesContent)"
          :key="item[0]"
          :title="item[1].title"
          :description="item[1].description"
          :icon="item[1].icon"
          :class="item[1].class"
          class="mb-5"
        >
          <template #button>
            <button
              class="btn btn-outline-primary w-100"
              @click="() => handleDistributionChange(item[0])"
            >
              Wybierz
            </button>
          </template>
        </DistributionTile>
      </div>
    </template>
    <template v-else>
      <div v-if="showChosenDistribution">
        <h3 class="step-title">Wybrana dystrubucja</h3>
        <DistributionTile
          :title="distributionTypesContent[distribution].title"
          :description="distributionTypesContent[distribution].description"
          :icon="distributionTypesContent[distribution].icon"
          :class="distributionTypesContent[distribution].class"
          active
          class="mb-5"
        >
          <template #button>
            <button
              class="btn btn-outline-primary w-100"
              @click="() => handleDistributionChange(null)"
            >
              Zmień dystrybucję
            </button>
          </template>
        </DistributionTile>
      </div>
      <div v-if="pageType === 'form'"  class="row">
        <div v-if="isVirtualCard && !isProductNDEExternalDistribution" class="col-md-12 col-lg-12">
          <div class="formWrapper virtualCardForm mb-5">
            <div class="formWrapper__inner">
              <h5 class="font-weight-bold">KROK 1 – POBIERZ SZABLON Z PLIKIEM XLS</h5>
              <p>
                Aby zamówić Wirtualne Karty Pluxee pobierz szablon z plikiem XLS i uzupełnij go
                niezbędnymi danymi (imię, nazwisko, email, kwota doładowania karty).
              </p>
              <p><strong>Wszystkie dane zapisz w jednym pliku.</strong></p>
              <p class="mt-5"><a class="btn btn-outline-primary w-100" href="/docs/formularze_zamowien/szablon-pliku-z-danymi-kart-wirtualnych.xlsx"> Pobierz szablon </a></p>
            </div>
          </div>
          <div class="formWrapper virtualCardForm">
            <div class="formWrapper__inner">
              <h5 class="font-weight-bold">KROK 2 – DODAJ WYPEŁNIONY DANYMI PLIK XLS</h5>
              <p>
                Na podstawie tych danych wyślemy dostępy do kart wirtualnych bezpośrednio
                do użytkowników na wskazane w pliku adresy email. Prosimy o dokładne sprawdzenie
                wszystkich danych, w szczególności adresów e-mail oraz kwot doładowania karty.
              </p>
              <p>
                <b>Wypełniony plik XLS dodaj do zamówienia.</b><br>
                Na jego podstawie zobaczysz poniżej podsumowanie zamówienia.
              </p>
              <p class="my-5">
                <a class="preview-link" @click="isEmailPreviewModalOpen = !isEmailPreviewModalOpen">
                  <span class="mi mi-info-fill"></span>Obejrzyj jak będzie wyglądał email, który otrzymają użytkownicy.
                </a>
                <virtual-card-email-preview-modal
                  :product-slug="this.$store.state.products.all.products[0].slug"
                  :is-email-preview-modal-open="isEmailPreviewModalOpen"
                  v-on:handleModalOpen="handleModalOpen"
                >
                </virtual-card-email-preview-modal>
              </p>
              <ValidationProvider :rules="fileSummary.length > 0 ? null : 'required'" v-slot="{ validate, errors }" tag="div" class="form-group" ref="fileValidator">
                <div>
                  <input type="file" id="file" ref="file" @change="sendVirtualCardFile($event) || validate($event)" style="display: none">
                  <a id="button" class="btn btn-outline-primary w-100" @click="handleFileButtonClick">{{getMessage}}</a>
                  <img src="/images/loader.gif" v-if="isUploading" />
                  <ul class="errors">
                    <li class="text-danger">{{ errors[0] }}</li>
                  </ul>
                </div>
              </ValidationProvider>
              <CustomAlert class="form-error-alert my-5" type="warning" :open="Boolean(errorMessage)" @update:open="errorMessage = ''">
                <b>Uwaga!</b><br />{{ errorMessage }}
              </CustomAlert>
              <div class="row cardUsers" v-if="!isUploading && fileSummary.length > 0">
                <div class="col-xs-12">
                  <h4>Podsumowanie pliku:</h4>
                    <div class="cardUsers__tableWrapper">
                      <table class="table table-striped cardUsers__table">
                        <thead>
                          <tr>
                            <th>Email</th> <th>Imię</th> <th>Nazwisko</th> <th>Kwota</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr  v-for="item in fileSummary" :key="item.email+item.amount" >
                            <td>{{item.email}}</td>
                            <td>{{item.first_name}}</td>
                            <td>{{item.last_name}}</td>
                            <td>{{item.amount}}</td>
                          </tr>
                        </tbody>
                      </table>
                      <p class="pull-right">Suma: <b> {{total}}</b></p>
                    </div>
                </div>
              </div>
            </div>
          </div>
          <product-form :delivery_id="0" :main="true" hide-main-product></product-form>
        </div>
      </div>
      <div v-if="!isVirtualCard || isProductNDEExternalDistribution || pageType === 'productPage'" class="row">
        <div class="col-md-12 col-lg-12">
          <product-form :delivery_id="0" :main="true"></product-form>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import axios from 'axios';
import { uuid } from 'uuidv4';
import { ValidationProvider } from 'vee-validate';
import VirtualCardEmailPreviewModal from '@/components/Modals/virtualCardEmailPreviewModal.vue';
import ProductForm from '@/components/Product/ProductForm.vue';
import { checkProductsIsGift, checkProductsIsVirtualCard } from '@/utils/categoryUtils';
import virtualCardRepository from '@/repositories/virtualCardRepository';
import { createProductToCartData, productToCartFactory } from '@/utils/cartProductFactory';
import { DataLayerManager } from '@/utils/DataLayerManager';
import CustomAlert from '@/components/CustomAlert.vue';
import DistributionTile from '@/components/DistributionTile.vue';
import { distributionType } from '@/utils/constants/distribution';

export default {
  name: 'step1',
  components: {
    VirtualCardEmailPreviewModal,
    ValidationProvider,
    ProductForm,
    CustomAlert,
    DistributionTile,
  },
  props: ['pageType'],
  data() {
    return {
      isFileSent: false,
      isError: false,
      isUploading: false,
      isRequestCompleted: false,
      token: null,
      errorMessage: '',
      alert: '',
      isEmailPreviewModalOpen: false,
      isGift: false,
    };
  },
  created() {
    this.token = uuid();
    this.handleSaveDeliveryToken();
    this.isGift = checkProductsIsGift(this.$store.state.products.all.products[0]);
  },
  methods: {
    handleFileButtonClick() {
      this.$refs.file.value = null;
      this.$refs.file.click();
    },
    sendVirtualCardFile() {
      const file = this.$refs.file.files[0];

      if (file && file !== '') {
        this.$store.dispatch('virtualCard/setVirtualCardFile', file);
        this.$store.dispatch('virtualCard/setVirtualCardToken', this.token);
        this.submitFile(file);
      }
    },
    resetCart() {
      this.$store.dispatch('delivery/reset');
      this.$store.dispatch('confection/resetConfection');
    },
    async submitFile(file) {
      this.resetCart();
      this.isUploading = true;
      const productId = this.$store.state.products.all.products[0].idproducts;
      virtualCardRepository.checkFile(this.token, file, productId.toString())
        .then(({ data }) => {
          if (data.error) {
            this.isError = true;
            this.isUploading = false;
            this.isRequestCompleted = true;
            this.$store.dispatch('virtualCard/setFileSummary', []);
            this.$store.dispatch('virtualCard/setTotal', 0);
            this.errorMessage = data.error.message;
            this.$store.dispatch('delivery/reset');
          } else {
            this.isUploading = false;
            this.isError = false;
            this.isRequestCompleted = true;
            this.$store.dispatch('virtualCard/setFileSummary', data.records);
            this.$store.dispatch('virtualCard/setTotal', data.totalAmount);
            const productToCard = createProductToCartData(data, this.$store.getters.allProducts[0], 0);
            productToCard.forEach((product) => {
              this.$store.dispatch('delivery/addVirtualCardToCart', product);
              DataLayerManager.pushAddToCartEvent(product);
            });
          }
        })
        .catch((error) => {
          this.isError = true;
          this.isUploading = false;
          this.isRequestCompleted = true;
          this.$store.dispatch('virtualCard/setFileSummary', []);
          this.$store.dispatch('virtualCard/setTotal', 0);
          this.errorMessage = error.message;
        });
    },
    handleSaveDeliveryToken() {
      this.$store.dispatch('delivery/setDeliveryToken', { index: 0, token: this.token });
    },
    handleModalOpen() {
      this.isEmailPreviewModalOpen = !this.isEmailPreviewModalOpen;
    },
    replaceImgWithDefault(e) {
      e.target.src = `${process.env.VUE_APP_BASE_URL}/media/ESPI_fallback.png`;
    },
    resetVirtualCardState() {
      this.$store.dispatch('virtualCard/setVirtualCardFile', '');
      this.$store.dispatch('virtualCard/setVirtualCardToken', '');
      this.$store.dispatch('virtualCard/setFileSummary', []);
      this.$store.dispatch('virtualCard/setTotal', 0);
    },
    handleDistributionChange(value) {
      this.resetCart();
      this.resetVirtualCardState();
      this.$store.dispatch('additionalInfo/handleDistributionChange', value);
    },
  },
  computed: {
    ...mapState({
      fileSummary: state => state.virtualCard.fileSummary,
      total: state => state.virtualCard.total,
    }),
    ...mapGetters({
      isProductVirtualNDE: 'isProductVirtualNDE',
      isProductNDEExternalDistribution: 'isProductNDEExternalDistribution',
      distribution: 'additionalInfo/distribution',
    }),
    distributionTypesContent() {
      return {
        [distributionType.CLIENT]: {
          title: 'Dystrybucja własna',
          description: 'Po opłaceniu zamówienia będziesz miał możliwość samodzielnego rozesłania dostępów do kart wirtualnych wybranym przez Ciebie osobom w dowolnym momencie.',
          icon: 'envelope-green',
          class: 'green',
        },
        [distributionType.SODEXO]: {
          title: 'Dystrybucja za pośrednictwem Pluxee',
          description: 'Po opłaceniu zamówienia, dostępy do kart wirtualnych zostaną wysłane przez nas do wskazanych osób zgodnie z plikiem excel, który załączysz w trakcie składania zamówienia.',
          icon: 'envelope-yellow',
          class: 'yellow',
        },
      };
    },
    isVirtualCard() {
      return checkProductsIsVirtualCard(this.$store.state.products.all.products[0]);
    },
    distributionType() {
      return distributionType;
    },
    showDistributionPicker() {
      return this.isProductVirtualNDE && this.distribution === null;
    },
    showChosenDistribution() {
      return this.isProductVirtualNDE && this.distribution !== null;
    },
    deliveryNo() {
      return this.$store.state.cart.deliveries_no;
    },
    getToken() {
      return this.$store.state.delivery.address[this.delivery_id].token || '';
    },
    cartItemsCount() {
      return this.$store.getters['delivery/getItemsCount'] > 0;
    },
    getMessage() {
      // if (this.hasDeliveryFile) return 'Prześlij plik ponownie...';
      return 'Dodaj plik';
    },
    product() {
      return this.$store.state.products.all.products[0];
    },
    productImageUrl() {
      return `${process.env.VUE_APP_BASE_URL}/media/ESPI_${this.product.slug}.png`;
    },
  },
};
</script>

<style scoped lang="scss" >
.pointer-cursor {
  cursor: pointer;
  text-decoration: underline;
}
</style>
